/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers';
import type { Provider } from '@ethersproject/providers';
import type { IDefiBridge, IDefiBridgeInterface } from '../IDefiBridge.js';

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetB',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetB',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_auxData',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '_rollupBeneficiary',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'outputValueB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isAsync',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetB',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetB',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_auxData',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'outputValueB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'interactionComplete',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
];

export class IDefiBridge__factory {
  static readonly abi = _abi;
  static createInterface(): IDefiBridgeInterface {
    return new utils.Interface(_abi) as IDefiBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IDefiBridge {
    return new Contract(address, _abi, signerOrProvider) as IDefiBridge;
  }
}
